
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/email",
      function () {
        return require("private-next-pages/destinations/email.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/email"])
      });
    }
  